import styled from 'styled-components';

export const RecurrenceMenuWrapper = styled.div`
  display: flex;
  width: 35%;
  margin-right: 12px;
  & > div {
    overflow: visible !important;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }

  ${(props) => props.theme.breakpoints.down('lg')} {
    width: 100%;
    max-width: 552px;
    margin: 0;
    padding: 0;
    & > div {
      overflow: visible !important;
      width: 100%;
      max-width: 100%;
      padding-top: 0;
    }
  }
`;
